<template>
    <ul class="nav_breadcrumbs">
        <li>
            <router-link to="/modules/home">{{lang.LBL_HOME}}</router-link>
        </li>
        <li>
            <router-link to="/modules/opportunitys/edit">{{lang.LBL_ADD_OPPORTUNITY}}</router-link>
        </li>
        <li>
            <router-link to="/modules/opportunitys">{{lang.LBL_VIEW_OPPORTUNITY}}</router-link>
        </li>
    </ul>
</template>
<script>
    import lang from "@/views/modules/Opportunitys/language/en";
    export default {
        name: "breadcrumbs",
        data() {
            return {
                lang: [],
            }
        },
        mounted() {
            this.lang = lang;
        },

    }
</script>